import React from "react";

import { css } from "styled-components";

export const StyledStaffLines = css`
    position: absolute;
    right: calc(100% - 10px);
    top: 0;
    height: 100%;
    pointer-events: none;

    display: flex;
    align-items: center;
    svg {
        width: 100vw;
        line {
            stroke: ${p => p.theme.c.snowOnActive};
            stroke-width: 1px;
        }
    }
`;

export const StaffLines = () => (
    <svg width="100%" height="40" viewBox="0 -7.5 100 41" preserveAspectRatio="none">
        <line x1="0" x2="100" y1="1" y2="1"></line>
        <line x1="0" x2="100" y1="7" y2="7"></line>
        <line x1="0" x2="100" y1="13" y2="13"></line>
        <line x1="0" x2="100" y1="19" y2="19"></line>
        <line x1="0" x2="100" y1="25" y2="25"></line>
    </svg>
);
